import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=3b0f5922&scoped=true"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"
import style0 from "./collection.vue?vue&type=style&index=0&id=3b0f5922&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f5922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0f5922')) {
      api.createRecord('3b0f5922', component.options)
    } else {
      api.reload('3b0f5922', component.options)
    }
    module.hot.accept("./collection.vue?vue&type=template&id=3b0f5922&scoped=true", function () {
      api.rerender('3b0f5922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialcenter/reconciliation/collection.vue"
export default component.exports